import React from 'react'
import { Box, Grid, Stack } from '@mui/material'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import TextColorFontHeader from 'common/Typography/TextColorFontHeader'

/**
 * @returns a column grid, 2 rows
 */
export default function ProfileListInfo({
  title,
  fields,
  children,
  proportion
}: ProfileProps) {
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Stack direction='row' justifyContent='space-between'>
          <TextColorFontHeader>{title}</TextColorFontHeader>
          <Box>{children}</Box>
        </Stack>
        <Grid container>
          {fields.map((field, index) => {
            return (
              <Grid
                item
                key={field.fieldName + index}
                xs={proportion ? proportion : 12 / fields.length}
                sx={{
                  pr: 1,
                  color: '#818D9C',
                  fontSize: '0.8em'
                }}
              >
                {field.fieldName}
              </Grid>
            )
          })}
          <Grid item xs={proportion ? 12 - proportion * fields.length : 0} />

          {fields.map((field, index) => {
            return (
              <Grid
                item
                key={field.fieldValue + index}
                xs={proportion ? proportion : 12 / fields.length}
                sx={{
                  pr: 1,
                  my: 1
                }}
              >
                <TextColorFontBody
                  sx={{
                    fontSize: '0.8em',
                    wordBreak: 'break-all'
                  }}
                >
                  {field.fieldValue}
                </TextColorFontBody>
              </Grid>
            )
          })}
          <Grid item xs={proportion ? 12 - proportion * fields.length : 0} />
        </Grid>
      </Box>
    </>
  )
}
interface ProfileProps {
  title: 'Profile' | 'Billing Cycle' | 'Plan' | string
  fields: {
    fieldName: string
    fieldValue: string
  }[]
  children?: React.ReactNode
  proportion?: number | undefined
}
